import instance from "../apis/axiosConfig";

// CREATE
export const createCustomer = (data) =>
  instance.post("customers/create", data);

// GET
export const getCustomers = (page, limit) =>
  instance.get(`customers/getAll?page=${page}&limit=${limit}`);

// UPDATE
export const updateCustomer = (id, data) =>
  instance.post(`customers/update/${id}`, data);

// DELETE
export const deleteCustomer = (id) =>
  instance.delete(`customers/delete/${id}`);

// IMAGE UPDATE
export const updateCustomerImage = (id, data) =>
  instance.post(`customers/update-image/${id}`, data);

// PUBLISH
export const updateCustomerPublish = (id, data) =>
  instance.post(`customers/update-publish-status/${id}`, data);

// PRIORITY
export const updateCustomerPriority = (data) =>
  instance.post("customers/priority", data);